import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/Logo";
import { WHATSAPP_LINK } from "@/site";
import { useLang } from "@/i18n";

const FloatingWhatsApp = () => {
  const { t } = useLang();
  return (
    <motion.a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.float.aria}
      data-testid="floating-whatsapp-button"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="group fixed bottom-6 end-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-ink text-bone shadow-[0_12px_35px_rgba(0,0,0,0.25)] transition-colors duration-300 hover:bg-clay"
    >
      <span className="absolute inset-0 rounded-full border border-ink/30 transition-transform duration-500 group-hover:scale-125" aria-hidden="true" />
      <WhatsAppIcon className="h-6 w-6 transition-transform duration-300 group-hover:scale-110" />
    </motion.a>
  );
};

export default FloatingWhatsApp;
